import { useState } from 'react';

const useIsOpen = () => {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };
  return { isOpen, close, open };
};

export default useIsOpen;
